const INITIAL_YEAR = 2023;
export const getCurrentYear = () => new Date().getFullYear();

export function getAvailableYears() {
  const currentYear = getCurrentYear();
  const result = [];
  for (let i = currentYear; i >= INITIAL_YEAR; i--) {
    result.push(i);
  }

  return result;
}
